import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  viewChild,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatCardModule } from '@angular/material/card'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatIcon } from '@angular/material/icon'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatDividerModule } from '@angular/material/divider'
import { MatDatepicker } from '@angular/material/datepicker'
import { MatInputModule } from '@angular/material/input'
import { emailValidator } from '../../../shared/utils/email_validator'
import moment from 'moment'
import { MatTableModule } from '@angular/material/table'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator'
import { MatProgressBar } from '@angular/material/progress-bar'
import { ConsultantService } from '../../../core/services/person/consultant/consultant.service'
import {
  cnpjTransform,
  cpfTransform,
  formatDateForm,
  responseDefaultForm,
} from '../../../shared/utils/utils'
import { NgxMaskDirective } from 'ngx-mask'
import { MatButton } from '@angular/material/button'
import { TableListConsultantComponent } from '../../../shared/components/table-list-consultant/table-list-consultant.component'
import { FormClientSearchComponent } from '../../../shared/components/form-client-search/form-search.component'
import { ConsultantClientComponent } from '../../../pages/customer/consultant-client/consultant-client.component'
import { LegalEntityClientComponent } from '../../../pages/customer/legal-entity-client/legal-entity-client.component'
import { MatTab, MatTabsModule } from '@angular/material/tabs'
import { JsonPipe } from '@angular/common'

@Component({
  selector: 'client-edit',
  imports: [
    MatInputModule,
    MatIcon,
    MatPaginator,
    MatTableModule,
    MatIcon,
    MatPaginatorModule,
    MatProgressBar,
    MatCardModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    MatDividerModule,
    MatProgressSpinner,
    NgxMaskDirective,
    MatButton,
    TableListConsultantComponent,
    FormClientSearchComponent,
    ConsultantClientComponent,
    LegalEntityClientComponent,
    MatTabsModule,
    JsonPipe,
  ],
  templateUrl: './consultant-client-person-edit.component.html',
  styleUrl: './consultant-client-person-edit.component.scss',
  providers: [ConsultantService],
  standalone: true,
})
export class ConsultantClientPersonEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private consultantService: ConsultantService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ConsultantClientPersonEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cdr: ChangeDetectorRef,
  ) {
    this.item = this.data
    const today = new Date() // Data atual
    const currentYear = today.getFullYear()
    const currentMonth = today.getMonth()
    const currentDay = today.getDate()
    this.maxDate = new Date(currentYear - 18, currentMonth, currentDay)
  }

  @Output() response = new EventEmitter()
  datepicker = viewChild<MatDatepicker<any>>('birth')
  // @ViewChild('birth') datepicker: MatDatepicker<any> | undefined

  form: FormGroup = new FormGroup({})
  item: any = {}
  loadingBIcon: boolean = false
  loadingScreen: boolean = false
  loadingBtn: boolean = false
  maxDate!: Date

  loadingClient: boolean = false
  pageClient: number = 1
  rowsClient: number = 10
  totalClient: number = 0
  listClient: any[] = []
  columnsClient: any[] = [
    {
      keyColumn: 'name',
      key: 'nome_desc',
      description: 'Nome',
    },
    {
      keyColumn: 'type',
      key: 'tipo',
      description: 'Tipo',
    },
    {
      keyColumn: 'cpnj',
      key: 'documento_identificacao',
      description: 'Cpf/Cnpj',
    },
    {
      keyColumn: 'action',
      key: { add: false, remove: true },
      description: 'Ações',
    },
  ]

  loadingNotClient: boolean = false
  pageNotClient: number = 1
  rowsNotClient: number = 10
  totalNotClient: number = 0
  listNotClient: any[] = []
  columnsNotClient: any[] = [
    {
      keyColumn: 'name',
      key: 'nome_desc',
      description: 'Nome',
    },
    {
      keyColumn: 'type',
      key: 'tipo',
      description: 'Tipo',
    },
    {
      keyColumn: 'cpnj',
      key: 'documento_identificacao',
      description: 'Cpf/Cnpj',
    },
    {
      keyColumn: 'action',
      key: { add: true, remove: false },
      description: 'Ações',
    },
  ]

  listSearch: any = [
    { id: 'nome', description: 'Nome', type: 'string', visible: true },
    { id: 'cpf', description: 'CPF', type: 'string', visible: true },
    {
      id: 'cnpj',
      description: 'Razão Social',
      type: 'string',
      visible: true,
    },
    { id: 'razao', description: 'Cnpj', type: 'string', visible: true },
  ]

  inputSearchClient: any = { type: '', search: '' }
  searchFormClient: any = { search: false, model: {} }

  inputSearchNotClient: any = { type: '', search: '' }
  searchFormNotClient: any = { search: false, model: {} }

  ngOnInit(): void {
    this.createForm()
    this.getClientsByConsultant()
    this.getNotClientsByConsultant()
  }

  close() {
    this.dialogRef.close(true)
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      phone: ['', [Validators.required, Validators.minLength(10)]],
      email: ['', [Validators.required, emailValidator()]],
      birth: [''],
    })
    this.form.get('name')?.setValue(this.item.nome)
    this.form.get('email')?.setValue(this.item.email)
    this.form.get('phone')?.setValue(this.item.telefone)
    this.form
      .get('birth')
      ?.setValue(
        this.item.dataNascimento && this.item.dataNascimento != ''
          ? moment(this.item.dataNascimento, 'DD/MM/YYYY').toDate()
          : '',
      )
    this.cdr.detectChanges()

    // this.form = this.formBuilder.group({
    //   name: [this.item.nome, [Validators.required, Validators.minLength(3)]],
    //   phone: [
    //     this.item.telefone,
    //     [Validators.required, Validators.minLength(10)],
    //   ],
    //   email: [this.item.email, [Validators.required, emailValidator()]],
    //   birth: [moment(this.item.dataNascimento, 'DD/MM/YYYY').toDate()],
    // })

    this.loadingScreen = false
  }

  treatResponseClient(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        let cpf_cnpj =
          item.tipoPessoaId == 1
            ? cpfTransform(item.cnpjCpf)
            : cnpjTransform(item.cnpjCpf)

        list.push({
          ...item,
          tipo: item.tipoPessoaId == 1 ? 'Cliente Física' : 'Cliente Jurídica',
          documento_identificacao: cpf_cnpj,
          nome_desc: item.nome,
        })
      }
    }
    this.listClient = list
    this.totalClient = response.totalItens
  }

  treatResponseNotClient(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        let cpf_cnpj =
          item.tipoPessoaId == 1
            ? cpfTransform(item.cpf)
            : cnpjTransform(item.cnpj)
        let nome_desc = item.tipoPessoaId == 1 ? item.nome : item.nomeFantasia
        list.push({
          ...item,
          nome_desc: nome_desc,
          tipo: item.tipoPessoaId == 1 ? 'Cliente Física' : 'Cliente Jurídica',
          documento_identificacao: cpf_cnpj,
        })
      }
    }
    this.listNotClient = list
    this.totalNotClient = response.totalItens
  }

  getClientsByConsultant() {
    this.loadingClient = true
    this.consultantService
      .listPagedConsultantClientById(
        this.item.id,
        this.pageClient,
        this.rowsClient,
      )
      .subscribe({
        next: (response: any) => {
          this.treatResponseClient(response)
          this.loadingClient = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loadingClient = false
        },
        complete: () => {
          this.loadingClient = false
        },
      })
  }

  searchClientsByConsultant() {
    this.loadingClient = true
    this.consultantService
      .searchPagedClientConsultant(
        this.pageClient,
        this.rowsClient,
        this.searchFormClient.model,
      )
      .subscribe({
        next: (response: any) => {
          this.treatResponseClient(response)
          this.loadingClient = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loadingClient = false
        },
        complete: () => {
          this.loadingClient = false
        },
      })
    this.loadingClient = true
  }

  getNotClientsByConsultant() {
    this.loadingNotClient = true
    this.consultantService
      .listPagedConsultantNotClientById(
        this.item.id,
        this.pageNotClient,
        this.rowsNotClient,
      )
      .subscribe({
        next: (response: any) => {
          this.treatResponseNotClient(response)
          this.loadingNotClient = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loadingNotClient = false
        },
        complete: () => {
          this.loadingNotClient = false
        },
      })
  }

  searchNotClientsByConsultant() {
    this.loadingNotClient = true
    this.consultantService
      .searchPagedClientConsultant(
        this.pageClient,
        this.rowsClient,
        this.searchFormClient.model,
      )
      .subscribe({
        next: (response: any) => {
          this.treatResponseNotClient(response)
          this.loadingNotClient = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loadingNotClient = false
        },
        complete: () => {
          this.loadingNotClient = false
        },
      })
  }

  editModel() {
    return {
      id: this.item.id,
      nome: this.form.controls['name'].value,
      email: this.form.controls['email'].value,
      telefone: this.form.controls['phone'].value,
      nascimento: formatDateForm(this.form.controls['birth'].value),
      // this.form.controls['birth'].value != ''
      //   ? moment(this.form.controls['birth'].value).format('DD/MM/YYYY')
      //   : '',
    }
  }

  editConsultant() {
    this.loadingBtn = true
    const model = this.editModel()
    this.consultantService.editConsultant(model).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.loadingBtn = false
      },
      error: (err: ErrorRequestModel) => {
        this.loadingBtn = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loadingBtn = false
      },
    })
  }

  openDatepicker() {
    this.datepicker()?.open()
  }

  uploadListClient(type: 'new' | '' = '') {
    if (type == 'new') {
      this.searchFormClient = { search: false, model: {} }
    }
    if (this.searchFormClient.search) {
      this.searchClientsByConsultant()
    } else {
      this.getClientsByConsultant()
    }
  }

  uploadListNClient(type: 'new' | '' = '') {
    if (type == 'new') {
      this.searchFormNotClient = { search: false, model: {} }
    }
    if (this.searchFormNotClient.search) {
      this.searchNotClientsByConsultant()
    } else {
      this.getNotClientsByConsultant()
    }
  }

  search(event: any, type: 'TClient' | 'TNClient') {
    if (event.search) {
      if (type == 'TClient') {
        this.searchFormClient = {
          search: true,
          model: this.createModel(event.data),
        }
      } else if (type == 'TNClient') {
        this.searchFormNotClient = {
          search: true,
          model: this.createModel(event.data),
        }
      }
    }
    if (type == 'TClient') {
      this.pageClient = 1
      this.uploadListClient(!event.search ? 'new' : '')
    } else if (type == 'TNClient') {
      this.pageNotClient = 1
      this.uploadListNClient(!event.search ? 'new' : '')
    }
  }

  createModel(element: any) {
    let model: any = {
      pessoaId: this.item.id,
      tipoPessoa: ['cnpj', 'razao'].includes(element.type) ? 2 : 1,
    }
    for (let i = 0; i < this.listSearch.length; i++) {
      const item = this.listSearch[i]
      model[item.id] =
        item.id == element.type
          ? element.search
          : responseDefaultForm(item.type)
    }
    return model
  }

  pageChanged($event: any, type: 'TClient' | 'TNClient') {
    if (type == 'TNClient') {
      this.pageNotClient = $event.pageIndex + 1
      this.rowsNotClient = $event.pageSize
      this.uploadListNClient()
    } else if (type == 'TClient') {
      this.pageClient = $event.pageIndex + 1
      this.rowsClient = $event.pageSize
      this.uploadListClient()
    }
  }

  addItem(element: any) {
    this.loadingBIcon = true
    const model = {
      consultorId: this.item.id,
      clienteId: element.id,
    }
    this.consultantService.addConsultantClient(model).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.uploadListClient()
        this.uploadListNClient()
      },
      error: (err: ErrorRequestModel) => {
        this.loadingBIcon = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loadingBIcon = false
      },
    })
  }

  removeItem(element: any) {
    this.loadingBIcon = true
    const model = {
      consultorId: this.item.id,
      clienteId: element.clienteId,
    }
    this.consultantService.removeConsultantClient(model).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.uploadListClient()
        this.uploadListNClient()
      },
      error: (err: ErrorRequestModel) => {
        this.loadingBIcon = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loadingBIcon = false
      },
    })
  }
}
